import { render, staticRenderFns } from "./IkinciSatisForm.vue?vue&type=template&id=7f5a4336"
import script from "./IkinciSatisForm.vue?vue&type=script&lang=ts"
export * from "./IkinciSatisForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports